export type QueryParams = {
  checkId: number ;
  location: string;
  token: string;
  date: Date;
};

export type CheckCurrentStatus = {
  status: Status;
  host: string;
  date: Date;
  location: string;
};

export type Report = {
  status: Status;
  host: string;
  date: Date;
  reportDetail: ReportDetail;
  currentAgentStatus: StatusResult;
  checkInterval: number;
  location: string;
  locationLabel: string;
  expiresInMinutes: number;
  responseTime: ResponseTime;
  traces: Array<Trace>;
  downtimeBreakdown: Array<DownTime>;
};

export type Trace = {
  location: string;
  locationLabel: string;
  checkedAt: Date;
  traceroute: string;
  status: string;
  geotraceroute: {
    traceroute: Traceroute;
    hops: Array<Hop>;
  };
};

export type Traceroute = {
  to: TraceTo;
  from: TraceFrom;
  hops: string;
};

export type TraceFrom = {
  host: string;
  lat: number;
  long: number;
  city: string;
  region: string;
  country: string;
  ASNumber: number;
  ASOrganizationName: string;
};

export type TraceTo = {
  host: string;
  ip: string;
  lat: number;
  long: number;
  city: string;
  region: string;
  country: string;
  ASNumber: number;
  ASOrganizationName: string;
};

export type Hop = {
  line: number;
  host: string;
  ip: string;
  rtt: "0.194";
  lat: number;
  long: number;
  city: string;
  region: string;
  country: string;
  ASNumber: number;
  ASOrganizationName: string;
};

export type DownTime = {
  date: Date;
  result: [
    {
      start: Date;
      end: Date;
    }
  ];
};

export type ResponseTime = {
  dates: Array<number>;
  values: Array<number>;
};

export type StatusResult = {
  checkId: number;
  mostRecentCheckValues: Array<StatusItem>;
}

export type StatusItem = {
  dnsLookupTime: number,
  responseTime: number,
  site: string,
  siteLabel: string
  status: string,
  timestamp: string; // ISO 8601 format date string
}

export type FullReport ={
  report: Report,
  status: StatusResult
};

export type ReportDetail = {
  checkId: number;
  errorMessage: string;
  checkRunAt: number;
  reporterMonitorId: string;
  reporterMonitorLabel: string;
  status: Status;
  verificationPolicy: verificationPolicy;
  verifierMonitorId: string;
  verifierMonitorLabel: string;
}

export enum verificationPolicy {
  "SIMPLE", "MAJORITY"
}

export enum Status {
  NEW = "NEW", 
  NEUTRAL = "NEUTRAL", 
  UP = "UP", 
  DOWN = "DOWN", 
  UNCONFIRMED_UP = "UNCONFIRMED_UP", 
  CONFIRMED_UP = "CONFIRMED_UP", 
  CONFIRMED_DOWN = "CONFIRMED_DOWN", 
  UNCONFIRMED_DOWN = "UNCONFIRMED_DOWN", 
  UNDETERMINED = "UNDETERMINED"
}
